import React, { Component } from "react";
import AddClass from "../AddClass/AddClass";

class EditClass extends Component {
  render() {
    return <AddClass editStatus={true} levelId={this.props.match.params.id} />;
  }
}

export default EditClass;
